<template>
  <b-container>
    <b-row>
      <b-col xl="10" offset-xl="1">
        <h2 style="margin: 25px">
          {{ $t(tableData.listTitleLabel || ("label_administration_" + tableData.name + "_displayName")) }}
        </h2>
        <div style="font-size: 1.1rem; margin: 25px 0px">
          {{ $t(tableData.listDescriptionLabel || ( "label_administration_" + tableData.name + "_description")) }}
        </div>
        <b-row v-if="rows > perPage || searchTerm">
          <b-col></b-col>
          <b-col cols="4" class="search-col">
            <b-form-input
              id="filter-input"
              v-model="searchTerm"
              type="search"
              :placeholder="$t('label_administration_searchTerm')"
            ></b-form-input>
          </b-col>
        </b-row>
        <b-table
          v-if="retrievedData"
          id="table"
          :per-page="perPage"
          :fields="fields"
          :current-page="currentPage"
          :responsive="true"
          striped
          hover
          :items="retrievedData"
          tbody-tr-class="rowClass"
          @row-clicked="onRowClick"
          :filter="searchTerm"
          @filtered="onFiltered"
          :sort-by.sync="sortBy"
        >
          <template #cell()="{ value }">
            {{ $t(value) | formatDate }}

          </template>
          <!--          <template v-slot:cell(Many)="data">
            <div v-for="(manyField,manyIndex) of tableData.ManyToManyRelationships"
                 @click="openManyModal(data.item[tableData.idName],manyField)">
              Add {{ manyField.tableName }}
            </div>

          </template>-->

          <!--          <template v-slot:cell(Edit)="data">
            <div @click="setEdit(data.item[tableData.idName])">Edit</div>
          </template>

          <template v-slot:cell(Select)="data">
            <div @click="setEdit(data.item[tableData.idName])">Select</div>
          </template>

          <template v-slot:cell(Check)="data">
            <div>
              <b-form-checkbox
                v-model="data.item.checked"
                @change="setCheck(data.item[tableData.idName])"
              >

              </b-form-checkbox>
            </div>
          </template>-->
        </b-table>
        <b-pagination
          v-if="retrievedData"
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="table"
        />
      </b-col>
    </b-row>
    <b-modal
      id="modalInfo"
      v-model="showModal"
      modal-class="modalInfo"
      :title="$t('')"
    >
      <div style="max-height: 600px; overflow-y: scroll">
        <div v-for="(md, indexMany) in manyData" :key="indexMany">
          <b-form-checkbox
            v-model="md.status"
            @change="addMany(md[currentMany.id], md.status)"
          >
            {{ md[currentMany.name] }}
          </b-form-checkbox>
        </div>
      </div>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-btn @click="showModal = false"> Close </b-btn>
      </div>
    </b-modal>
  </b-container>
</template>
<script>
import { GetTableDataByName } from "./tablesConfiguration";
import { FieldType } from "../commons";
import { axiosCall } from "../axiosCall";
import { mapGetters } from "vuex";

export default {
  name: "IndicaList",
  computed: {
    ...mapGetters({
      getOptionListByName: "getOptionListByName",
    }),
  },
  props: {
    tableName: {
      type: String,
      default: null,
    },
    refresh: {
      type: Number,
      default: 0,
    },
    overrideFields: {
      type: Array,
      default: null,
    },
    checkedValues: {
      type: Array,
      default: null,
    },
    filter: {
      type: Object,
      default: null,
    },
    manyFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      retrievedData: null,
      perPage: 15,
      currentPage: 1,
      rows: 1,
      tableData: null,
      showModal: false,
      manyData: null,
      currentMany: null,
      currentId: null,
      FieldType: FieldType,
      searchTerm: null,
      fields: [],
      sortBy: null,
    };
  },
  watch: {
    refresh: async function () {
      await this.get();
    },
    filter: async function () {
      await this.get();
    },
    tableName: async function () {
      await this.getTableData();
    },
    overrideFields: function () {
      if (this.overrideFields && this.overrideFields.length) {
        this.fields = this.overrideFields.map((field) => ({
          key: field,
          sortable: true,
        }));
        if(this.fields && this.fields.length){
          this.sortBy = this.fields[0].key
        }
      }
    },
  },
  created: async function () {
    await this.getTableData();
  },
  methods: {
    onRowClick(record, index) {
      this.$emit("onRowClick", record, index);
    },
    getTableData: async function () {
      if (this.tableName) {
        this.tableData = GetTableDataByName(this.tableName);
        this.tableData.fieldsToShow = [...this.tableData.fieldsToShow];
        this.fields = this.tableData.fieldsToShow.map((field) => ({
          key: field,
          sortable: true,
        }));
        if(this.fields && this.fields.length){
          this.sortBy = this.fields[0].key
        }
        // 'Edit',
        if (this.tableData.ManyToManyRelationships.length > 0) {
          // this.tableData.fieldsToShow.push('Many')
        }
        const selecFields = this.tableData.fields.filter(
          (field) => field.type === FieldType.SELECT
        );
        await selecFields.map(async (field) => {
          if (field.selectTablename) {
            await axiosCall({ url: field.selectTablename, method: "get" }).then(
              (response) => {
                field.selectOptions = response.data.map((data) => {
                  return {
                    value: data[field.selectId],
                    text: data[field.selectName],
                  };
                });
              }
            );
          }
          if (field.selectOptionsName) {
            field.selectOptions = this.getOptionListByName(
              field.selectOptionsName
            ).map((data) => {
              return {
                value: data.id,
                text: this.$t(data.name),
              };
            });
          }
        });
        await this.get();
      }
    },
    setEdit: function (id) {
      this.$emit("edit", id);
    },
    setCheck: function (id) {
      this.$emit("check", id);
    },
    openManyModal: async function (id, many) {
      this.currentMany = many;
      this.currentId = id;
      await this.getMany(many.tableName);
      await this.getManyInserted();
      this.showModal = true;
    },
    getManyInserted: async function () {
      const where = {};
      where["where"] = {};
      where["where"][this.currentMany.localField] = this.currentId;
      await axiosCall({
        url:
          `${this.currentMany.breakingTableName}?filter=` +
          JSON.stringify(where),
        method: "get",
      }).then((s) => {
        this.manyData.map((manyD) => {
          var element = s.data.filter(
            (dd) =>
              dd[this.currentMany.foreignField] === manyD[this.currentMany.id]
          );
          if (element.length > 0) {
            manyD.status = true;
            manyD.relationshipId = element[0].id;
          }
        });
      });
    },
    addMany: async function (manyId, checked) {
      if (checked === true) {
        this.manyData
          .filter((many) => many[this.currentMany.id] === manyId)
          .map(async (many) => {
            await axiosCall({
              url: `${this.currentMany.breakingTableName}/${many.relationshipId}`,
              method: "delete",
            });
          });
      } else {
        const data = {};
        data[this.currentMany.localField] = this.currentId;
        data[this.currentMany.foreignField] = manyId;
        await axiosCall({
          url: this.currentMany.breakingTableName,
          method: "put",
          data: data,
        }).then((s) => {
          this.manyData
            .filter((many) => many[this.currentMany.id] === manyId)
            .map((many) => {
              many.relationshipId = s.data.id;
            });
        });
      }
      this.$emit("manyChanged", { manyId, checked });
    },
    get: async function () {
      const selectFields = this.tableData.fields
        .filter((field) => field.type === FieldType.SELECT)
        .map((field) => field.name);
      console.log(selectFields);
      await axiosCall({
        url:
          this.tableData.endpoint +
          (this.filter ? "?filter=" + JSON.stringify(this.filter) : ""),
        method: "get",
      }).then((response) => {
        this.retrievedData = response.data.map(d=>{
          var keys = Object.keys(d);
          for (let key of keys) {
            d[`${key}_translated`] = this.$t(d[key]);
          }
          return d;
        });
        this.retrievedData.map((row) => {
          Object.keys(row).map((key) => {
            if (selectFields.includes(key)) {
              if (this.checkedValues && this.tableData.idName === key) {
                if (this.checkedValues.includes(row[key])) {
                  this.row.checked = true;
                }
              }
              this.tableData.fields
                .filter((fieldS) => fieldS.name === key)
                .map((field) => {
                  field.selectOptions
                    .filter((so) => so.value === row[key])
                    .map((so) => {
                      row[key] = so.text;
                    });
                });
            }
          });
        });
        if (this.tableData.sortBy) {
          this.retrievedData.sort((a, b) =>
            a[this.tableData.sortBy].localeCompare(b[this.tableData.sortBy])
          );
        }
        this.rows = this.retrievedData.length;
      });
    },
    lowerFirstLetter: function (string) {
      return string.charAt(0).toLowerCase() + string.slice(1);
    },
    getMany: async function (table) {
      await axiosCall({
        url:
          table +
          (this.manyFilter ? "?filter=" + JSON.stringify(this.manyFilter) : ""),
        method: "get",
      }).then((response) => {
        this.manyData = response.data;
      });
    },
    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
<style lang="scss">
.rowClass {
  cursor: pointer;
}
.search-col{
  margin-bottom: 20px;
}
</style>
